import { Component, OnInit } from '@angular/core';
import { SidebarService, UserService, TranslationService } from '../../services/services.index';
import { User } from '../../models/user.model';
import { Router } from '@angular/router';

declare var swal: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit {

  user: User;

  constructor(public _sidebar: SidebarService,
    public router: Router,
    public _userService: UserService,
    public _translationService: TranslationService) { }

  ngOnInit() {
    this.user = this._userService.user;
    this._sidebar.loadMenu();
  }

  navegar(componente: string) {
    if (this._userService.user.pago || this._userService.user.role === 'ADMIN_ROLE') {
      this.router.navigate([componente]);
    } else {
      let lang: string = this._translationService.lang;
      let tituloSwal: string;
      let mensajeSwal: string;
      if (lang === 'es') {
        tituloSwal = 'Realizar Pago';
        mensajeSwal = 'Para realizar esta accion deberá enviar el pago primero. Muchas Gracias';
      } else {
        tituloSwal = 'Make payment';
        mensajeSwal = 'To perform this action you must send the payment first. Thank you so much';
      }
      swal(tituloSwal, mensajeSwal, 'error');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts